export default [
    {
        _name: "CSidebarNav",
        _children: [
            // {
            //   _name: 'CSidebarNavItem',
            //   name: 'Dashboard',
            //   to: '/dashboard',
            //   icon: 'cil-speedometer',
            // },

            {
                _name: "CSidebarNavItem",
                name: "Tournaments",
                icon: "cil-pencil",
                to: "/tournaments",
            },
            {
                _name: "CSidebarNavItem",
                name: "Instruction",
                icon: "cil-notes",
                to: "/tournamentInfo",
            },
        ],
    },
];
